import GLOBAL from './GLOBAL';

class AuthHelper {
  static isLoggedIn() {
    return GLOBAL.get('user') && GLOBAL.get('token');
  }
}

export default AuthHelper;